module.exports = __webpack_public_path__ + "img/img07.38d5c48f.svg";